<template>
    <a 
        role="button"
        @click="toggleButton"
    >
        <span class="icon">
            <i 
                :class="{
                    'clicked': isClicked
                }"  
                class="transition mdi mdi-chevron-right mdi-24px"
            ></i>
        </span>
    </a>
</template>

<script>
export default {
    name: 'ChevronIcon',
    props: {
        tableProps: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            isClicked: false,
        };
    },
    methods: {
        toggleButton() {
            this.tableProps.toggleDetails(this.tableProps.row)

            this.isClicked = !this.isClicked
            this.$emit('checkIfIsAllToggled')
        }
    }
};
</script>
<style lang="scss">
.transition {
  transition: all 300ms ease-in-out;
}

.clicked {
  transform: rotate(90deg);
}
</style>
